var map = {
	"./add-icon.svg": 9508,
	"./api-icon.svg": 8439,
	"./arrow-down-black.svg": 2383,
	"./arrow-down-step.svg": 4104,
	"./arrow-down.svg": 9201,
	"./arrow-icon.svg": 6386,
	"./arrow-left.svg": 6234,
	"./arrow-right.svg": 401,
	"./arrow-up-step-orange.svg": 6328,
	"./arrow-up-step.svg": 3925,
	"./arrow.svg": 32,
	"./book-icon.svg": 8892,
	"./check-icon.svg": 1403,
	"./clone-icon.svg": 1042,
	"./coins-icon.svg": 169,
	"./copy-icon.svg": 5224,
	"./create-icon.svg": 5549,
	"./dietician-icon.svg": 7341,
	"./dislike-icon.svg": 2535,
	"./engineer-icon.svg": 1660,
	"./history-icon.svg": 1347,
	"./home-icon.svg": 666,
	"./home.svg": 9720,
	"./huiren-logo.svg": 312,
	"./like-icon.svg": 8314,
	"./market-icon-orange.svg": 8692,
	"./market-icon.svg": 7793,
	"./merge-icon.svg": 3031,
	"./merge-tool.svg": 3138,
	"./mind-icon.svg": 8349,
	"./model-tool-orange.svg": 962,
	"./model-tool.svg": 2035,
	"./more-icon.svg": 852,
	"./my-assistant-icon.svg": 8966,
	"./my-copilot-icon.svg": 7262,
	"./my-market-icon.svg": 2358,
	"./okr-button.svg": 8652,
	"./okr-icon.svg": 6883,
	"./p-icon.svg": 5695,
	"./paper-icon-gray.svg": 9227,
	"./paper-icon.svg": 4633,
	"./person-icon.svg": 2444,
	"./question-icon.svg": 4881,
	"./refresh-icon.svg": 8804,
	"./s-button-icon.svg": 3729,
	"./s-button.svg": 3581,
	"./search-icon.svg": 3269,
	"./service-background-icon.svg": 2871,
	"./service-icon-black.svg": 526,
	"./service-icon.svg": 5207,
	"./service1.svg": 6839,
	"./service2.svg": 2244,
	"./service3.svg": 261,
	"./setting-icon.svg": 959,
	"./share-icon.svg": 7928,
	"./shoppingcar-icon.svg": 7805,
	"./trophy-icon.svg": 4883,
	"./umb-logo-new.svg": 416,
	"./umb-logo.svg": 9885,
	"./upload-icon.svg": 7828,
	"./upload-tool.svg": 6505,
	"./user-avatar.svg": 2418,
	"./vector1.svg": 3529,
	"./vector2.svg": 7530,
	"./vector3.svg": 9499,
	"./vector4.svg": 7876,
	"./vector5.svg": 9157,
	"./vector7.svg": 5735,
	"./vector8.svg": 8816,
	"./voice-icon.svg": 5937,
	"./voice-tool.svg": 9984,
	"./voice.svg": 2253,
	"./web-tool.svg": 7364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2282;